import { Experiment } from '@ms/yammer-data/dist/state/types';

import { useExperimentTreatmentWithoutReporting } from '../experiments';

import { useCanCurrentUserAccessAdminSettings } from './useCanCurrentUserAccessAdminSettings';

type UseCanCurrentUserAccessWebAdminSettings = () => boolean;
export const useCanCurrentUserAccessWebAdminSettings: UseCanCurrentUserAccessWebAdminSettings = () => {
  const isAdminSettingsEnabled = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAdminWeb) === true;
  const canUserAccessAdminSettings = useCanCurrentUserAccessAdminSettings();

  return isAdminSettingsEnabled && canUserAccessAdminSettings;
};
